export const formatUser = user => (
  `${user.lastName?.toUpperCase()} ${user.firstName} (${user.reference})`
)
